<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="근린생활시설 평면도" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>근린생활시설 평면도</template>

            <div class="page-section__content">
                <div class="sub-tabs">
                    <v-tabs grow hide-slider centered v-model="tab" class="v-tabs--density-compact">
                        <template v-for="(item, index) in items">
                            <tab-quarternary :key="index">
                                {{ item.name }}
                            </tab-quarternary>
                        </template>
                    </v-tabs>
                </div>
            </div>

            <div class="page-section__content">
                <sheet-secondary align="center" class="pa-0">
                    <v-tabs-items v-model="tab">
                        <template v-for="(item, index) in items">
                            <v-tab-item :key="index" eager>
                                <img :src="item.image" alt="" />
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </sheet-secondary>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import TabQuarternary from "@/components/publish/parents/tabs/tab-quarternary.vue";
import SheetSecondary from "@/components/publish/parents/sheets/sheet-secondary.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        TabQuarternary,
        SheetSecondary,
    },
    data: () => ({
        tab: null,
        items: [
            {
                name: "지하 1층",
                image: "/images/sub/complex/neighborhood/neighborhood-1.jpg",
            },
            {
                name: "지상 1층",
                image: "/images/sub/complex/neighborhood/neighborhood-2.jpg",
            },
            {
                name: "지상 2층",
                image: "/images/sub/complex/neighborhood/neighborhood-3.jpg",
            },
            {
                name: "지상 24층",
                image: "/images/sub/complex/neighborhood/neighborhood-4.jpg",
            },
            {
                name: "옥상",
                image: "/images/sub/complex/neighborhood/neighborhood-5.jpg",
            },
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>
